import React, { FunctionComponent, ReactNode } from 'react';
import * as styles from './Inline.module.scss';

export type GrowItemProps = {
  children: ReactNode;
  component?: keyof HTMLElementTagNameMap | FunctionComponent<any>;
};

/**
 * Wraps a child of `Inline` so it grows to fill the remaining space on the row,
 * while sibling items stay sized to their content — for example an input that
 * should fill the row beside a fixed-width button.
 *
 * `min-width: 0` lets the item shrink below its content's intrinsic width so it
 * can truncate rather than overflow the row.
 *
 * Renders a `div` by default. Pass `component` to render a different element
 * (e.g. `li`) so the wrapper stays valid inside a semantic `Inline` container.
 */
export const GrowItem = ({ children, component = 'div' }: GrowItemProps) =>
  React.createElement(component, { className: styles.growItem }, children);
